import React, { useEffect, useMemo, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import { File, FolderTree } from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import { Link } from "react-router";
import ProjectQuickView from "./popup";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableFilterReturn,
  TableFirstCol,
  TableHead,
  TableHeaderWrap,
  TableLink,
  TableRow,
} from "../../../../component/table/table-layout";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../component/icons/action-card-icon";
import StatusChip from "../../../../component/ui/chip/status";
import Tooltip from "../../../../component/ui/tooltip";
import InvoiceQuickView from "../../../../component/invoice/InvoiceQuickView";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import ChevronDownIcon from "../../../../component/icons/chevron-down";
import FileCode1Icon from "../../../../component/icons/file-code-1";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import ListIcon from "../../../../component/icons/list";
import ProjectBoard from "./kanban/LeadBoard";
import ProjectProcessBoard from "./project-process/LeadBoard";
import AvatarProfile from "../../../../component/ui/profile";
import Avatar from "../../../../component/ui/avatar";
import UpperTabs from "../../../../component/upper-tab";
import projectUpperTabIcons from "../../../../component/icons/project-upper-tab-icons";
import { TitleHeading } from "../../../../component/ui/layout";

const Project = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [exportTo, setExportTo] = useState(false);
  const [viewType, setViewType] = useState("list");

  const [boardFilters, setBoardFilters] = useState([]);
  const [showBoardFilterModal, setShowBoardFilterModal] = useState(false);
  const [groupBy, setGroupBy] = useState(); // default
  const [boardSaveFilters, setBoardSaveFilters] = useState([]);

  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(100);

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedProjects(apiData.map((d) => d.project_key));
    } else {
      setSelectedProjects([]);
    }
  };

  // ✅ Toggle Single Row
  const toggleSelectRow = (project_key) => {
    setSelectedProjects((prev) =>
      prev.includes(project_key)
        ? prev.filter((id) => id !== project_key)
        : [...prev, project_key],
    );
  };

  const handleExport = async (type, localData = null) => {
    try {
      // ✅ If user already selected rows (local data)
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Projects...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // 🧩 Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      const res = await apiCall({
        url: `projects/projects-list`,
        method: "post",
        data: apiData,
      });

      const projectsData = res?.data || res?.projects || [];
      if (!projectsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No project data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(projectsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportData = (data, type) => {
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const formattedData = data.map((row) => {
      const obj = {};

      obj["Customer Name"] = row?.name || "-";
      obj["Customer Email"] = row?.email || "-";
      obj["Customer Phone"] = row?.phone || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (
          [
            "project_name",
            "customer_details",
            "customer_name",
            "customer_email",
            "customer_phone",
          ].includes(key)
        )
          return; // skip duplicates

        if (key === "agent_details") {
          obj[label || "Agent"] = row?.agent_details?.name || "-";
        } else if (key === "package_details") {
          obj[label || "Package"] = row?.package_details?.packagename || "-";
        } else if (key === "status") {
          obj[label || "Status"] = row?.status || "-";
        } else if (key === "payment") {
          obj[label || "Payment"] = row?.payment || "-";
        } else if (key === "invoiceid") {
          obj[label || "Invoice ID"] = row?.invoiceid || "-";
        } else if (["created_at", "signupdate"].includes(key)) {
          obj[label || key] = row[key]
            ? dayjs(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else {
          obj[label || key] =
            typeof row[key] === "object" && row[key] !== null
              ? JSON.stringify(row[key])
              : (row[key] ?? "-");
        }
      });

      return obj;
    });

    // 📁 File name
    const fileName = `projects_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    // 💾 Export logic
    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Projects");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Project data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  // const statusColor = {
  //   pending: "bg-amber-50 text-amber-700 border border-amber-200",

  //   in_progress: "bg-blue-50 text-blue-700 border border-blue-200",

  //   revision: "bg-purple-50 text-purple-700 border border-purple-200",

  //   on_hold: "bg-rose-50 text-rose-700 border border-rose-200",

  //   completed: "bg-emerald-50 text-emerald-700 border border-emerald-200",
  // };

  const statusColor = {
    completed: { background: "#E6F9F0", color: "#0F9D58" }, // emerald green
    on_hold: { background: "#E8F0FE", color: "#1A73E8" }, // royal blue
    pending: { background: "#fff3e0", color: "#e65100" }, // deep orange
    in_progress: { background: "#F3E8FF", color: "#9333EA" }, // violet
    revision: { background: "#E0F7FA", color: "#00838F" }, // cyan / teal
    "no answer update 2": { background: "#f3f4f6", color: "#374151" }, // cyan / teal
    "wrong number": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
    "call back": { background: "#fffbeb", color: "#78350f" }, // cyan / teal
    "not interested": { background: "#fee2e2", color: "#b91c1c" }, // cyan / teal
    "do not contact": { background: "#f9fafb", color: "#374151" }, // cyan / teal
    duplicate: { background: "#ede9fe", color: "#5b21b6" },
  };
  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getProducts();
    getBrands();
  }, []);

  const [tabs, setTabs] = useState([]);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 100 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `projects/projects-list?view=myprojects${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTabs(res?.shortcut_filters);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    setSelectedIds([]);
    getData({});
    setChangeModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const filterModalData = [
    {
      name: "name",
      label: "Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "email",
      label: "Email",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "email",
    },
    {
      name: "phone",
      label: "Phone",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "number",
    },
    {
      name: "source",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: products,
      dropdownKey: "products",
      dropdownVal: "products",
    },
    {
      name: "page_source",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: brands,
      dropdownKey: "brandname",
      dropdownVal: "brandurl",
    },
    {
      name: "startdate",
      label: "Start Date",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
    },
  ];

  const getBoardFilterData = () => {
    if (groupBy === "leadsource") return filterModalData;
    if (groupBy === "created_time") return filterModalData;
    return filterModalData; // default
  };

  const getBoardFilter = (val) => {
    setBoardSaveFilters(val);
  };

  const [productionUsers, setProductionUsers] = useState([]);

  const getUsers = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "users/production-users-list",
      });

      setProductionUsers(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const tableRef = useRef(null);

  const [activeTab, setActiveTab] = useState(null);

  const changeFilter = (val, eachTab) => {
    // console.log("Change filter");
    // console.log("val", val);
    // console.log("eachTab", eachTab);

    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filter: updatedFilter });
      } else {
        getData({
          filter: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    setActiveTab(val);
  };

  const filteredData = useMemo(() => {
    if (!activeTab) return apiData;

    return apiData.filter((eachData) => {
      const fieldValue = eachData?.[activeTab?.header_key];
      const filterValue = activeTab.value;

      if (Array.isArray(fieldValue)) {
        return fieldValue.includes(activeTab?.value);
      }

      if (typeof fieldValue === "string" && fieldValue.includes(",")) {
        return fieldValue
          .split(",")
          .map((item) => item.trim())
          .includes(filterValue);
      }

      return fieldValue === activeTab?.value;
    });
  }, [activeTab, apiData]);

  const [apiApiFilter, setapiApiFilter] = useState(false);

  const innerChange = (eachTab, i) => {
    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filter: updatedFilter });
      } else {
        getData({
          filter: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    let allTabs = [...tabs];
    allTabs.splice(2, 0, eachTab);
    allTabs.splice(i + 1, 1);
    setTabs(allTabs);
    setActiveTab({ value: eachTab?.value, header_key: eachTab?.header_key });
  };

  const [invoiceLoading, setInvoiceLoading] = useState(false);

  const getInvoiceDetails = async (project_key) => {
    setInvoicePopup(true);

    try {
      setInvoiceLoading(true);

      const res = await apiCall({
        method: "get",
        url: `transactions/get-invoice/${project_key}`,
      });

      setInvoiceData(res?.data);
    } catch (error) {
      console.warn("Invoice Error:", error);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={viewType == "list" ? filterReturn : boardFilters}
                onChange={(allFilter) => {
                  if (viewType == "list") {
                    setFilterReturn(allFilter);
                  } else {
                    setBoardFilters(allFilter);
                  }
                  getData({ filter: allFilter });
                }}
              />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {viewType === "list" ? (
                    // <div className={Style.bpfl_select}>
                    //   <select
                    //     onChange={(e) => {
                    //       getData({ page_quantity: e?.target.value });
                    //       setPageCount(1);
                    //       setPageItemsCount(e?.target.value);
                    //     }}
                    //   >
                    //     <option value="10">Projects View 10</option>
                    //     <option value="25">Projects View 25</option>
                    //     <option value="50">Projects View 50</option>
                    //     <option value="100">Projects View 100</option>
                    //     <option value="all">Projects View all</option>
                    //   </select>
                    // </div>
                    <div className="flex flex-col gap-1">
                      <TitleHeading
                        title={"Total Projects"}
                        className={"!pl-0"}
                      />
                      <h3 className="text-gray-500 text-[14px] flex items-center gap-1">
                        {isLoading ? (
                          <>
                            <span className="h-[16px] w-[30px] bg-gray-300 rounded animate-pulse" />
                            <span className="h-[16px] w-[50px] bg-gray-300 rounded animate-pulse" />
                          </>
                        ) : (
                          `${tablePagination?.total || 0} Projects`
                        )}
                      </h3>
                    </div>
                  ) : (
                    <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                      {viewType == "in-process"
                        ? "In Process Projects"
                        : "Project Pipeline"}
                    </div>
                  )}
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          (
                            viewType === "list"
                              ? filterReturn.length
                              : boardFilters.length
                          )
                            ? Style.active
                            : ""
                        }`}
                        onClick={() => {
                          if (viewType === "list")
                            setShowModalFilterTable(true); // list view ke liye
                          else {
                            setShowBoardFilterModal(true); // board view ke liye
                          }
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>
                    {/* <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"list view"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "list" ? Style.active : ""
                        }`}
                        onClick={() => {
                          setViewType("list");
                          setGroupBy();
                        }}
                      >
                        <div className={Style.icon}>
                          <ListIcon size={16} />
                        </div>
                      </div>
                    </Tooltip> */}

                    <div
                      className={`${Style.bpfl_action} ${
                        viewType === "list" ? null : Style.disabled
                      }`}
                    >
                      <Tooltip
                        className={`${Style.bpfl_actionItems}`}
                        content={"Customize Table"}
                        position={"left center"}
                      >
                        <div
                          className={`${Style.bpfl_actionBtn}`}
                          onClick={() => {
                            setShowModalCustomizeTabs(true);
                          }}
                        >
                          <div className={Style.icon}>
                            <LayoutTopIcon />
                          </div>
                        </div>
                      </Tooltip>
                    </div>

                    <CustomDropdown
                      position="bottom-right"
                      className={`myDropdown`}
                    >
                      <CustomDropdownButton arrow={false} className="btnClass">
                        <DotsVerticalIcon />
                      </CustomDropdownButton>

                      <CustomDropdownMenu>
                        {/* <CustomDropdownMenuList
                          onClick={() => {
                            setViewType("project-process");
                          }}
                        >
                          <div className="d-flex align-items-center gap-1">
                            <FolderTree size={14} /> States
                          </div>
                        </CustomDropdownMenuList> */}

                        <CustomDropdownMenuList
                          className={Style.CustomDropdownMenuList}
                          closed={false}
                        >
                          <div
                            className={Style.CustomDropdownMenuListBtn}
                            onClick={() => setExportTo(!exportTo)}
                          >
                            <div className="">
                              <LayoutTopIcon /> Export to
                            </div>
                            <div
                              className={`${Style.dropArrow} ${
                                exportTo ? Style.isActive : null
                              }`}
                            >
                              <ChevronDownIcon />
                            </div>
                          </div>

                          {exportTo ? (
                            <div className={Style.subItemMenu}>
                              <CustomDropdownMenuList
                                className={Style.subItemList}
                                onClick={() => {
                                  const dataToExport =
                                    selectedProjects.length > 0
                                      ? apiData.filter((d) =>
                                          selectedProjects.includes(
                                            d.projectid,
                                          ),
                                        )
                                      : apiData;

                                  // ✅ Call the new unified export function
                                  handleExport("csv", dataToExport);
                                }}
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <FileCode1Icon /> CSV
                                </div>
                              </CustomDropdownMenuList>

                              <CustomDropdownMenuList
                                className={Style.subItemList}
                                onClick={() => {
                                  const dataToExport =
                                    selectedProjects.length > 0
                                      ? apiData.filter((d) =>
                                          selectedProjects.includes(
                                            d.projectid,
                                          ),
                                        )
                                      : apiData;

                                  // ✅ Call the new unified export function
                                  handleExport("excel", dataToExport);
                                }}
                              >
                                <div className="d-flex align-items-center gap-1">
                                  <FileCode1Icon /> XLSX
                                </div>
                              </CustomDropdownMenuList>
                            </div>
                          ) : null}
                        </CustomDropdownMenuList>
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </div>
                </div>
              </div>

              {apiData?.length && !isLoading ? (
                <UpperTabs
                  activeTab={activeTab}
                  setActiveTab={changeFilter}
                  upparTabs={tabs?.length ? tabs : []}
                  totalEmp={apiData?.length}
                  userData={apiData}
                  DepartmentIcons={projectUpperTabIcons}
                  onInnerChange={innerChange}
                  isAllFilterShow={true}
                  upparTabsLimite={3}
                  UpparAllIcon={null}
                />
              ) : null}

              {/* BODY */}
              <div
                className={Style.empDirectory_body}
                style={
                  viewType == "list"
                    ? { height: "calc(100vh - 100px)" }
                    : { height: "calc(100vh - 50px)" }
                }
              >
                {viewType == "list" ? (
                  isLoading ? (
                    <InnerLoader />
                  ) : !apiData?.length ? (
                    <div className="flex justify-center items-center w-full h-full">
                      <DataNotFound title={"Projects"} />
                    </div>
                  ) : (
                    <>
                      <TableCard ref={tableRef}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell header sticky>
                                <div className="flex gap-2 items-center">
                                  <div className={Style.tableCheckBox}>
                                    <label className={Style.custom_checkbox}>
                                      <input
                                        type="checkbox"
                                        checked={
                                          selectedProjects.length ===
                                            apiData.length && apiData.length > 0
                                        }
                                        className={Style.customCheckbox}
                                        onChange={(e) =>
                                          toggleSelectAll(e.target.checked)
                                        }
                                      />
                                      <span className={Style.checkmark}></span>
                                    </label>
                                  </div>
                                  {/* <TableHeaderWrap>
                                    <span className="pl-[50px]">Client</span>
                                  </TableHeaderWrap> */}
                                </div>
                              </TableCell>
                              <TableCell header>
                                <div className="flex gap-4 items-center">
                                  <span>Email</span>
                                </div>
                              </TableCell>
                              <TableCell header>
                                <div className="flex gap-4 items-center">
                                  <span>Phone</span>
                                </div>
                              </TableCell>
                              {tableHeader?.map((eachHead, index) =>
                                eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                  <TableCell header key={index}>
                                    <TableHeaderWrap
                                      iconText={eachHead?.key}
                                      isIcon={true}
                                    >
                                      <span>{eachHead?.value}</span>
                                    </TableHeaderWrap>
                                  </TableCell>
                                ) : null,
                              )}
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {(apiApiFilter ? apiData : filteredData)?.map(
                              (eachList, index) => {
                                return (
                                  <TableRow key={`${index}`}>
                                    <TableCell sticky>
                                      <div
                                        className={`${Style.tableActionArea}`}
                                      >
                                        <div className="flex gap-2 items-center">
                                          <div className={Style.tableCheckBox}>
                                            <label
                                              className={Style.custom_checkbox}
                                            >
                                              <input
                                                type="checkbox"
                                                className={Style.customCheckbox}
                                                checked={selectedProjects.includes(
                                                  eachList.project_key,
                                                )}
                                                onChange={() =>
                                                  toggleSelectRow(
                                                    eachList.project_key,
                                                  )
                                                }
                                              />
                                              <span
                                                className={Style.checkmark}
                                              ></span>
                                            </label>
                                          </div>

                                          {/* <AvatarProfile
                                            src={
                                              eachList?.customer_details
                                                ?.userimg
                                            }
                                            title={
                                              eachList?.name
                                            }
                                          /> */}

                                          <TableFirstCol
                                            src={
                                              eachList?.customer_details
                                                ?.userimg
                                            }
                                            name={eachList?.name}
                                            emptype={eachList?.status}
                                            id={eachList?.package_name}
                                            data={eachList}
                                            isTypeTagShow={true}
                                          />
                                        </div>

                                        <div
                                          className={
                                            Style.tableActionAreaBtnGrpup
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => {
                                              setEmpPopup(true);
                                              setEmpData(eachList);
                                            }}
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#007AFF" }}
                                            >
                                              <NewEyeIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </div>

                                          <Link
                                            // to={`/projects/projectDetail/${eachList?.project_key}`}
                                            to={`/lead-account/detail/${eachList?.userid}/project/${eachList?.project_key}`}
                                            target="_blank"
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#34C759" }}
                                            >
                                              <NewCardIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </Link>
                                        </div>
                                      </div>
                                    </TableCell>

                                    <TableCell
                                      className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                    >
                                      {eachList?.email ? (
                                        <TableLink
                                          href={
                                            `mailto:${eachList?.email}` || ""
                                          }
                                          text={eachList?.email || "--"}
                                        />
                                      ) : (
                                        "--"
                                      )}
                                    </TableCell>
                                    <TableCell
                                      className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                    >
                                      {eachList?.phone || "--"}
                                    </TableCell>
                                    {tableHeader?.map((eachHead, i) =>
                                      eachHead.is_visible === 1 &&
                                      eachHead?.show == 1 ? (
                                        <>
                                          {eachHead.key === "status" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`text-center capitalize ${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {/* {eachList[eachHead?.key] ===
                                              "pending" ? (
                                              <StatusChip color="blue">
                                                {eachList[eachHead?.key] ||
                                                  "--"}
                                              </StatusChip>
                                            ) : eachList[eachHead?.key] ===
                                              "completed" ? (
                                              <StatusChip color="green">
                                                {eachList[eachHead?.key] ||
                                                  "--"}
                                              </StatusChip>
                                            ) : eachList[eachHead?.key] ===
                                              "cancelled" ? (
                                              <StatusChip color="red">
                                                {eachList[eachHead?.key] ||
                                                  "--"}
                                              </StatusChip>
                                            ) : (
                                              "-"
                                            )} */}
                                              <div
                                                className={`flex items-center text-sm gap-2 px-3 py-[2px] rounded-full cursor-pointer transition-all duration-200
                                                  `}
                                                style={
                                                  statusColor[
                                                    eachList[eachHead?.key]
                                                  ] || {
                                                    background: "#f5f5f5",
                                                    color: "#616161",
                                                  }
                                                }
                                                // ${statusColor[eachList[eachHead?.key]] || "bg-gray-100 text-gray-600 border border-gray-200"}
                                              >
                                                {eachList[eachHead?.key]
                                                  ? eachList[eachHead?.key]
                                                      ?.split("_")
                                                      .map(
                                                        (word) =>
                                                          word
                                                            .charAt(0)
                                                            .toUpperCase() +
                                                          word.slice(1),
                                                      )
                                                      .join(" ")
                                                  : null}
                                              </div>
                                            </TableCell>
                                          ) : eachHead.key === "payment" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`text-center capitalize ${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList.payment ? (
                                                <StatusChip
                                                  color={
                                                    eachList?.payment ==
                                                    "pending"
                                                      ? "blue"
                                                      : eachList?.payment ==
                                                          "success"
                                                        ? "green"
                                                        : eachList?.payment ==
                                                            "rejected"
                                                          ? "red"
                                                          : null
                                                  }
                                                >
                                                  {eachList[eachHead?.key] ||
                                                    "--"}
                                                </StatusChip>
                                              ) : (
                                                "-"
                                              )}
                                            </TableCell>
                                          ) : eachHead.key === "source" ? (
                                            <TableCell>
                                              <TableDepartmentTag>
                                                {eachList?.source}
                                              </TableDepartmentTag>
                                            </TableCell>
                                          ) : eachHead.key ===
                                            "agent_details" ? (
                                            <>
                                              {eachList?.agent_details ? (
                                                <TableCell
                                                  key={`${i}-${index}`}
                                                  className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                                >
                                                  {/* <div className="flex items-center gap-3">
                                                  <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                    {eachList?.agent_details
                                                      ?.userimg ? (
                                                      <img
                                                        src={`${eachList?.agent_details?.userimg}`}
                                                        alt={
                                                          eachList
                                                            ?.agent_details
                                                            ?.name
                                                        }
                                                        className="h-9 w-9 shrink-0 rounded-full object-cover object-center"
                                                        onError={(e) => {
                                                          e.target.classList.add(
                                                            "hidden",
                                                          );
                                                          if (
                                                            e.target
                                                              .parentElement
                                                          ) {
                                                            e.target.parentElement.innerHTML = `
                          <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                            ${
                              eachList?.agent_details?.name?.split(
                                " ",
                              )[0]?.[0] || ""
                            }
                            ${
                              eachList?.agent_details?.name?.split(
                                " ",
                              )[1]?.[0] || ""
                            }
                          </div>`;
                                                          }
                                                        }}
                                                      />
                                                    ) : (
                                                      <>
                                                        {eachList?.agent_details?.name?.split(
                                                          " ",
                                                        )[0]?.[0] || ""}
                                                        {eachList?.agent_details?.name?.split(
                                                          " ",
                                                        )[1]?.[0] || ""}
                                                      </>
                                                    )}
                                                  </div>
                                                  <span className="font-medium">
                                                    {eachList?.agent_details
                                                      ?.name || "-"}
                                                  </span>
                                                </div> */}
                                                  <AvatarProfile
                                                    src={
                                                      eachList?.agent_details
                                                        ?.userimg
                                                    }
                                                    title={
                                                      eachList?.agent_details
                                                        ?.name
                                                    }
                                                  />
                                                </TableCell>
                                              ) : (
                                                <TableCell
                                                  key={`${i}-${index}`}
                                                  className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                                >
                                                  -
                                                </TableCell>
                                              )}
                                            </>
                                          ) : eachHead.key === "invoice_id" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`text-blue-600 flex gap-2 items-center justify-between font-medium ${
                                                eachList?.dim_text == 1
                                                  ? "!text-[#9ca3af]"
                                                  : ""
                                              }`}
                                            >
                                              <span>
                                                {eachList[eachHead?.key] ?? "-"}
                                              </span>

                                              <div
                                                className={
                                                  "w-9 h-9 cursor-pointer flex items-center justify-center rounded-md"
                                                }
                                                onClick={() => {
                                                  if (eachList?.invoice_id) {
                                                    getInvoiceDetails(
                                                      eachList?.project_key,
                                                    );
                                                  }
                                                }}
                                              >
                                                <div
                                                  className={Style.icon}
                                                  style={{ color: "#34C759" }}
                                                >
                                                  <NewEyeIcon className="h-6.5 w-6.5" />
                                                </div>
                                              </div>
                                            </TableCell>
                                          ) : eachHead.key ===
                                            "assigned_users" ? (
                                            <>
                                              <TableCell
                                                key={`${i}-${index}`}
                                                className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                              >
                                                <div className="flex">
                                                  {Array.isArray(
                                                    eachList?.assigned_users,
                                                  ) &&
                                                  eachList?.assigned_users
                                                    ?.length > 0 ? (
                                                    eachList?.assigned_users?.map(
                                                      (each, idx) => (
                                                        <Tooltip
                                                          key={idx}
                                                          content={each?.name}
                                                          position="top center"
                                                        >
                                                          <div
                                                            className={`relative ${
                                                              idx !== 0
                                                                ? "-ml-2"
                                                                : ""
                                                            }`}
                                                          >
                                                            <Avatar
                                                              src={
                                                                each?.userimg
                                                              }
                                                              title={each?.name}
                                                              className="border-2 border-gray-200 shadow-sm "
                                                            />
                                                          </div>
                                                        </Tooltip>
                                                      ),
                                                    )
                                                  ) : (
                                                    <span className="text-gray-400 text-sm">
                                                      -
                                                    </span>
                                                  )}
                                                </div>
                                              </TableCell>
                                            </>
                                          ) : eachHead.key ===
                                            "package_details" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList?.package_details ? (
                                                <div className="flex flex-col">
                                                  <span className="font-medium text-gray-800">
                                                    {eachList?.package_details
                                                      ?.packagename || "-"}
                                                  </span>
                                                </div>
                                              ) : (
                                                "-"
                                              )}
                                            </TableCell>
                                          ) : (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`${eachList?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList[eachHead?.key] ?? "-"}
                                            </TableCell>
                                          )}
                                        </>
                                      ) : null,
                                    )}
                                  </TableRow>
                                );
                              },
                            )}
                          </TableBody>
                        </Table>
                      </TableCard>
                    </>
                  )
                ) : (
                  //  : viewType == "in-process" ? (
                  //   <ProjectBoard
                  //     filters={boardFilters}
                  //     groupBy={groupBy}
                  //     sendFilters={getBoardFilter}
                  //     onError={onError}
                  //     onSubmit={onSuccess}
                  //     productionUsers={productionUsers}
                  //     getUsers={() => {
                  //       getUsers();
                  //     }}
                  //   />
                  // )
                  <ProjectProcessBoard
                    filters={boardFilters}
                    groupBy={groupBy}
                    sendFilters={getBoardFilter}
                    onError={onError}
                    onSubmit={onSuccess}
                    productionUsers={productionUsers}
                    getUsers={() => {
                      getUsers();
                    }}
                  />
                )}
              </div>
              {/* FOOTER */}

              {viewType == "list" ? (
                !isLoading ? (
                  apiData?.length > 0 ? (
                    <div
                      className={`-mt-[12px] ${Style.table_footer}`}
                      style={{ alignItems: "center" }}
                    >
                      <div className={Style.table_footer_left}>
                        {`showing 1 to ${apiData?.length} of ${
                          tablePagination?.total || apiData?.length
                        }`}
                      </div>

                      {tablePagination ? (
                        <div className={Style.empDirectory_footer}>
                          {tablePagination?.next_page_url ? (
                            <button
                              className={`bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                                              hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                                              
                                              py-[10px] px-[17px] rounded-[5px] text-center 
                                              text-[#fff] text-[12px] font-semibold text-nowrap 
                                              flex items-center justify-center transition-all
                                              gap-1
                                              cursor-pointer min-w-[96px]`}
                              onClick={() => {
                                if (btnLoader) return;
                                setBtnLoader(true);
                                getData({
                                  page: tablePagination?.next_page_url,
                                });
                              }}
                            >
                              {btnLoader ? (
                                <InnerLoader
                                  className={`${Style.loader} !w-3 !h-3 !border-2`}
                                  textStatus={false}
                                />
                              ) : (
                                "Load More"
                              )}
                            </button>
                          ) : null}
                        </div>
                      ) : null}

                      <div
                        className={`${Style.table_footer_left} ${Style.rightText}`}
                      ></div>
                    </div>
                  ) : null
                ) : (
                  <div
                    className={Style.table_footer}
                    style={{ alignItems: "center" }}
                  >
                    <div className={Style.table_footer_left}>
                      <Skeleton width={"50%"} height={15} />
                    </div>

                    <div className={Style.empDirectory_footer}>
                      <Skeleton width={"180px"} height={40} />
                    </div>

                    <div
                      className={`${Style.table_footer_left} ${Style.rightText}`}
                    ></div>
                  </div>
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="projects-list"
        />
      )}

      {showBoardFilterModal && (
        <DynamicFilter
          data={getBoardFilterData()}
          onClose={() => setShowBoardFilterModal(false)}
          returnData={boardFilters}
          onSave={(filters) => {
            setBoardFilters(filters);
            setShowBoardFilterModal(false);
          }}
          saveFilter={boardSaveFilters}
          apiUrl={`projects/projects-kanban`}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="projects-list"
        />
      )}

      {empPopup && (
        <ProjectQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
        />
      )}

      {invoicePopup && invoiceData && (
        <InvoiceQuickView
          onClose={() => {
            setInvoicePopup(false);
            setInvoiceData(null);
          }}
          data={invoiceData}
          type="project"
          loading={invoiceLoading}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Project;
